import Swal from "sweetalert2"
import colors from "@/colors"

const Toast = Swal.mixin({
  position: "bottom-right",
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true,
  toast: true,
  color: colors.blue[900],
  customClass: {
    title: "!mt-3 !mx-0",
    icon: "!m-0 !border-0",
    popup: "!px-4 !py-2 !flex gap-3",
  },
})

export const toast = {
  info: (title, options) => Toast.fire({
    title,
    ...options,
  }),
  error: (title, options) => Toast.fire({
    title,
    iconHtml: "<i class=\"text-xl fa-solid fa-xmark text-red\"/>",
    ...options,
  }),
  success: (title, options) => Toast.fire({
    title,
    iconHtml: "<i class=\"text-xl fa-solid fa-check text-green\"/>",
    ...options,
  }),
}

window.toast = toast
